import {ListingType} from '@wearesection/bandai-react-components/molecules/FilterSelectionListing';
import {TypeDataFilter} from '@wearesection/bandai-react-components/organisms/ScrollingFilterListing';
import {Box} from '@mui/material';
import {cloneDeep} from 'lodash';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import {useRouter} from 'next/router';
import React, {useEffect, useMemo, useState} from 'react';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import {usePageSetting} from '~/providers/page-context.provider';
import {dateArithmetic, handleConvertToLocaleContentful, handleRemoveDuplicateItem} from '~/utils';
import * as Types from '../../graphql/types';
import {getPageData} from '../[[...slug]]/index.page';
import {REVALIDATE_TIME} from '~/constants';
import getListGameNoReleaseDate from '../[[...slug]]/get-list-game_no_release_date';
import {getListGameByQueryValue} from './get-list-game-by-query-value';
import getParamFilterBy from './get-param-filter-by';
import getParamSortBy from './get-param-sort-by';
import dynamic from 'next/dynamic';
import {GAME_LISTING_SOURCE} from '~/constants/content-map-type';
import getListBrand from './get-list-brand';
import getListGameForNav from '~/components/wrapper/organisms/navigation-bar/get-list-game';
import {getLitGameByIdBlock} from '~/components/wrapper/organisms/navigation-bar/get-list-game-by-id';
import {LIST_ID_GAME_OUR_PICK} from '~/constants';
const VerticalScrollingMoreGameContainerOrganisms = dynamic(
  () => import('~/components/wrapper/organisms/scrolling-infinity-more-game-container'),
  {ssr: false}
);

const ScrollingFilterGame = dynamic(
  () => import('~/components/wrapper/organisms/scrolling-filter-game'),
  {ssr: false}
);

const NotFoundOrganisms = dynamic(() => import('~/components/wrapper/organisms/not-found'), {
  ssr: false,
});

type PageGetGamesExt = {
  paramFilter: Types.FilterByCollection;
  paramSort: Types.SortByCollection;
  data: any;
  gameListingShooterAndAction: Types.GameCollection;
  gameListingParty: any[];
  locale: string;
  newDataOurPicks: any[];
  brandList: any[];
};

const Games: React.FC<PageGetGamesExt> = ({
  paramFilter,
  paramSort,
  data,
  gameListingShooterAndAction,
  locale,
  newDataOurPicks,
  gameListingParty,
  brandList,
}) => {
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [lengthItemDataFilter, setLengthItemDataFilter] = useState<number>(0);
  const [tagFilter, setTagsFilter] = useState<any[]>([]);
  const [titleFilterTag, setTitleFilterTag] = useState<string>('');
  const router = useRouter();
  const [filter, setFilter] = useState<any>({});
  const [sort, setSort] = useState<string>('New to old');

  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};

  let tags = router.query?.tag || null;
  const title = router?.query?.t || '';
  if (typeof tags === 'string') {
    tags = tags.split('-');
  }

  const handleTranslateBlogTagsToEnSg = (
    tags: any[],
    paramFilter: Types.FilterByCollection
  ): any[] => {
    const result: any[] = [];
    const listItemFilter = paramFilter?.items || [];

    if (tags?.length) {
      tags.map((tag: string) => {
        if (listItemFilter.length) {
          listItemFilter.map(filter => {
            if (filter?.title === tag) {
              result.push(filter.keyFilter);
            }
          });
        }
      });
    }

    return result;
  };

  // get value filter tags
  useEffect(() => {
    if (tags && typeof tags === 'object') {
      setTagsFilter([...handleTranslateBlogTagsToEnSg(tags, paramFilter)]);
      setLengthItemDataFilter(tags.length);
      setIsFilter(true);
    }
  }, [JSON.stringify(tags), paramFilter, dataTranslation]);

  // get title filter tags
  useEffect(() => {
    if (title) {
      setTitleFilterTag(title as string);
    }
  }, [JSON.stringify(title)]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }, [JSON.stringify(filter)]);

  // useEffect(() => {
  //   if (!lengthItemDataFilter) {
  //     setTagsFilter([]);
  //   }
  // }, [lengthItemDataFilter]);

  // Build brand filter from server-side data — no client-side API call needed
  const valueFilterCharacterOrSeries = useMemo(() => {
    if (!brandList?.length) return [];
    const result = brandList.map((item: any) => ({
      title: item.title,
      name: item.title,
      isChecked: false,
    }));
    if (!result.length) return [];
    return [
      {
        title: dataTranslation['filter-game-brands'],
        dataFilter: result,
        countSelect: 0,
        showMore: false,
        value: 'title',
      },
    ];
  }, [brandList, dataTranslation]);

  const handleFormatParamFilter = (listParamFilter: Types.FilterByCollection): TypeDataFilter[] => {
    const result: any[] = [];
    const listItemFilter = listParamFilter.items;

    const objFilter: any = {};
    if (listItemFilter.length) {
      listItemFilter.map(item => {
        if (item?.type?.title) {
          if (objFilter[item.type?.title]) {
            const valueFilter = {
              title: item?.title,
              name: item?.keyFilter,
              isChecked: false,
            };
            objFilter[item.type?.title]?.dataFilter.push(valueFilter);
            objFilter[item.type?.title].value = item?.typeFilter;
          } else {
            const valueFilter = {
              title: item?.title,
              name: item?.keyFilter,
              isChecked: false,
            };
            objFilter[item.type?.title] = {
              title: item?.type?.title,
              dataFilter: [valueFilter],
              countSelect: 0,
              showMore: false,
            };
          }
        }
      });
    }

    const newObjFilter: any = {};
    if (Object.values(objFilter).length) {
      for (const [key, value] of Object.entries(objFilter)) {
        if (key === dataTranslation['filter-game-platform']) {
          newObjFilter[0] = value;
        }
        if (key === dataTranslation['filter-game-genre']) {
          newObjFilter[1] = value;
        }
      }
    }

    if (Object.values(newObjFilter).length) {
      Object.values(newObjFilter).map((filter: any) => {
        const newDataFilter = filter?.dataFilter.sort((a: any, b: any) => {
          if (b.title < a.title) {
            return 1;
          }
          return -1;
        });

        result.push({
          ...filter,
          dataFilter: handleRemoveDuplicateItem(newDataFilter ?? [], 'title'),
        });
        return null;
      });
    }

    //Handle change position item filter
    const dataCut = result && result[0]?.dataFilter.splice(1, 3);
    if (result[0]?.dataFilter.concat(dataCut) !== undefined) {
      result[0].dataFilter = result[0].dataFilter.concat(dataCut) ?? '';
    }
    return result;
  };

  const handleFormatParamSort = (paramSort: Types.SortByCollection): ListingType[] => {
    const result: ListingType[] = [];
    const itemSort = paramSort.items;

    if (itemSort.length) {
      itemSort.map((sort: any) => {
        if (
          handleConvertToLocaleContentful(locale as string) !== 'en-SG' &&
          sort?.title?.includes('Title')
        )
          return null;

        const newSort = {
          title: sort.title,
          name: sort.title,
          isChecked: false,
        };

        result.push(newSort);

        return null;
      });
    }
    result.reverse();
    result[0].isChecked = true;
    return result;
  };

  const formatParamFilter = useMemo(
    () => handleFormatParamFilter(paramFilter),
    [paramFilter, dataTranslation]
  );
  const formatParamSort = useMemo(() => handleFormatParamSort(paramSort), [paramSort]);

  // handle set value filter and sort
  const handleFilter = (value: any, sort: any) => {
    const lengthKeyFilter = Object.keys(value).length;
    setIsFilter(!!lengthKeyFilter);
    setLengthItemDataFilter(lengthKeyFilter);
    setFilter(value);
    setTagsFilter([]);
    setSort(sort || 'New to old');
    setTitleFilterTag('');
  };

  const block: Array<any> = [
    data?.pageCollection?.items[0].sectionCollection?.items,
    data?.pageCollection?.items[0].seoStandard,
  ].filter(block => !!block);

  // Data of ScrollingThumbnailCard
  const blockCopy = cloneDeep(block);
  blockCopy[0].map((section: any, idx: number) => {
    if (
      blockCopy[0][idx].blocksCollection?.items[0]?.dataSource ===
      GAME_LISTING_SOURCE.gameListingOurPick
    ) {
      blockCopy[0][idx].blocksCollection.items[0] = {
        ...blockCopy[0][idx].blocksCollection.items[0],
        dataTranslation: dataTranslation,
        listItemCollection: {
          ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
          items: newDataOurPicks,
        },
      };
    }

    if (
      section?.blocksCollection?.items[0]?.dataSource === GAME_LISTING_SOURCE.gameListingParty &&
      gameListingParty?.length
    ) {
      blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
        ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
        items: gameListingParty,
      };
    }
    if (
      section?.blocksCollection?.items[0]?.dataSource === GAME_LISTING_SOURCE.gamesListingTowGenre
    ) {
      blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
        ...blockCopy[0][idx].blocksCollection.items[0].listItemCollection,
        items: gameListingShooterAndAction,
        dataTranslation: dataTranslation,
        formatParamFilter: formatParamFilter,
      };
    }
  });

  // Handle remove section when empty data
  const handleRemoveSectionWhenEmptyItem = () => {
    blockCopy[0].map((blockItem: any, idx: number) => {
      if (blockItem?.blocksCollection?.items[0]?.listItemCollection?.items?.length <= 0) {
        blockCopy[0].splice(idx, 1);
      }
    });
  };
  useMemo(() => {
    handleRemoveSectionWhenEmptyItem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <ScrollingFilterGame
        defaultTags={tagFilter}
        title={dataTranslation['game-listing-title']}
        sortBy={formatParamSort}
        sortByText={dataTranslation['filter-game-sort-by']}
        filterByText={dataTranslation['filter-game-filter-by']}
        showMoreText={dataTranslation['filter-game-show-more']}
        showLessText={dataTranslation['filter-game-show-less']}
        dataFilter={[...formatParamFilter, ...valueFilterCharacterOrSeries]}
        // dataFilter={[...formatParamFilter] ?? []}
        locale="vn"
        onFilter={(filter: any, sort: any) => {
          handleFilter(filter, sort);
        }}
        buttonPropsClear={{
          variant: 'secondary',
          label: dataTranslation['filter-game-clear'],
          disabled: false,
        }}
        buttonPropsDone={{
          variant: 'primaryDark',
          label: dataTranslation['filter-game-done'],
          disabled: false,
        }}
      />
      {(isFilter && !!lengthItemDataFilter) || (!!tagFilter.length && !!lengthItemDataFilter) ? (
        <Box>
          <VerticalScrollingMoreGameContainerOrganisms
            locale={locale}
            title={titleFilterTag?.replace(/-/g, '&')}
            dataQueryGame={filter}
            notFilter={false}
            paramSort={sort}
            tagFilter={tagFilter}
            lengthData={setLengthItemDataFilter}
            dataTranslation={dataTranslation}
          />
        </Box>
      ) : isFilter ? (
        <NotFoundOrganisms
          title={dataTranslation?.['title-games-listing-empty-state'] || 'Nothing to play here'}
          description={
            dataTranslation?.['description-games-listing-empty-state'] ||
            'Try another platform, genre or brand.'
          }
        />
      ) : null}
      {!isFilter && !tagFilter?.length && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <BlockRenderer block={blockCopy} />

          <VerticalScrollingMoreGameContainerOrganisms
            locale={locale}
            title={dataTranslation['game-listing-more-games']}
            paramSort={sort}
            tagFilter={tagFilter}
            dataTranslation={dataTranslation}
          />
        </Box>
      )}
      {/* <BlockRenderer block={[subscribe]} /> */}
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);
  const today = new Date();
  const locale: string = handleConvertToLocaleContentful(ctx?.locale as string) ?? '';

  const [
    [paramFilter, paramSort, pageData, getListGameUpcoming],
    brandData,
    [navGameLatest, navOurPicks],
  ] = await Promise.all([
    Promise.all([
      getParamFilterBy(handleConvertToLocaleContentful((ctx.locale as string) ?? '')),
      getParamSortBy(handleConvertToLocaleContentful((ctx.locale as string) ?? '')),
      getPageData({slug: 'games', preview}, ctx),
      getListGameNoReleaseDate(
        handleConvertToLocaleContentful((ctx.locale as string) ?? ''),
        0,
        20,
        {},
        Types.GameOrder.ReleaseDateAsc,
        {
          from: today.toISOString(),
          to: dateArithmetic(today, 6).toISOString(),
        }
      ),
    ]),
    getListBrand(0, 50, locale),
    Promise.all([
      getListGameForNav(locale, 0, 6, {}, 'releaseDate_DESC'),
      getLitGameByIdBlock(LIST_ID_GAME_OUR_PICK[locale] ?? LIST_ID_GAME_OUR_PICK['en-sg'], locale),
    ]),
  ]);
  const brandList = (brandData?.gameBrandCollection?.items ?? []).map(item => {
    return {title: item?.title};
  });

  const page = pageData.data?.pageCollection?.items[0];

  const ourPicks =
    page?.sectionCollection?.items[0]?.blocksCollection?.items?.[0]?.listItemCollection?.items ??
    [];

  if (!page) {
    return {
      redirect: {
        destination: `/${ctx.locale}/404`,
        permanent: false,
      },
    };
  }

  const blockPartyList = page.sectionCollection?.items?.[3]?.blocksCollection?.items?.[0] || {};
  let partyListGame: any[] = [];
  if (!(blockPartyList?.listItemCollection?.items || []).length) {
    partyListGame = await getListGameByQueryValue(
      handleConvertToLocaleContentful(ctx.locale as string),
      page.sectionCollection?.items?.[3] ?? {}
    );
  }

  const navData = {
    gameLatest: (navGameLatest?.items ?? []).map(item => {
      return {
        slug: item?.slug ?? '',
        title: item?.title ?? '',
      };
    }),
    ourPicks: (navOurPicks ?? []).map(item => {
      return {
        slug: item?.slug ?? '',
        title: item?.title ?? '',
        mainThumbnailImg: {
          media: {
            url: item?.mainThumbnailImg?.media?.url ?? '',
          },
        },
      };
    }),
  };

  const listGameByQueryValue = await getListGameByQueryValue(
    handleConvertToLocaleContentful(ctx.locale as string),
    page.sectionCollection?.items?.[4] ?? {}
  );

  const dataUpcomingSoon = (getListGameUpcoming?.items ?? []).map(item => {
    return {
      slug: item?.slug ?? '',
      title: item?.title ?? '',
      platform: item?.platform || [],
      mainThumbnailImg: item?.mainThumbnailImg ?? {},
      releaseDate: item?.releaseDate ?? '',
    };
  });

  const newDataOurPicks = ourPicks.map((item: any) => {
    return {
      slug: item?.slug ?? '',
      title: item?.title ?? '',
      platform: item?.platform || [],
      mainThumbnailImg: item?.mainThumbnailImg ?? {},
      description: item?.description ?? '',
      mastheadGalleryCollection: item?.mastheadGalleryCollection ?? {},
    };
  });

  const filterData = {
    items: paramFilter?.items.map(item => {
      return {
        keyFilter: item?.keyFilter ?? '',
        title: item?.title ?? '',
        typeFilter: item?.typeFilter ?? '',
        type: {title: item?.type?.title ?? ''},
      };
    }),
  };

  const sectionCollection = pageData?.data.pageCollection?.items?.[0]?.sectionCollection?.items.map(
    (items: any) => {
      const typeName = items.blocksCollection?.items?.[0]?.__typename;
      const type = items.blocksCollection?.items?.[0]?.type;
      const dataSource = items.blocksCollection?.items?.[0]?.dataSource;
      const blocksCollection = items.blocksCollection?.items?.[0];
      const sys = {
        __typename: items?.__typename,
        theme: items?.theme,
        noPadding: items?.noPadding,
      };

      if (type === 'FeaturedCardCarousel') {
        return {
          ...sys,
          blocksCollection: {
            __typename: blocksCollection?.__typename ?? null,
            items: [
              {
                dataSource,
                description: blocksCollection?.description ?? null,
                openNewTab: blocksCollection?.openNewTab ?? false,
                queryValue: blocksCollection?.queryValue ?? null,
                title: blocksCollection?.title ?? null,
                type,
                __typename: typeName,
                listItemCollection: {
                  items: blocksCollection?.listItemCollection?.items.map((item: any) => {
                    return {
                      audio: item?.audio ?? null,
                      description: item?.description ?? null,
                      slug: item?.slug ?? null,
                      subtitle: item?.subtitle ?? null,
                      title: item?.title ?? null,
                      platform: item?.platform ?? null,
                      mainThumbnailImg: {
                        media: {
                          url: item?.mainThumbnailImg?.media?.url ?? null,
                        },
                      },
                      mastheadGalleryCollection: {
                        items: item?.mastheadGalleryCollection?.items.map((i: any) => {
                          return {
                            caption: i?.caption ?? null,
                            internalName: i?.internalName ?? null,
                            media: i?.media ?? null,
                            url: i?.url ?? null,
                            videoEmbed: i?.videoEmbed ?? null,
                          };
                        }),
                      },
                    };
                  }),
                },
              },
            ],
          },
        };
      }
      if (type === 'ThumbnailCardWithPublicDate') {
        return {
          ...sys,
          blocksCollection: {
            __typename: blocksCollection?.__typename ?? null,
            items: [
              {
                dataSource,
                description: blocksCollection?.description ?? null,
                openNewTab: blocksCollection?.openNewTab ?? false,
                queryValue: blocksCollection?.queryValue ?? null,
                title: blocksCollection?.title ?? null,
                type,
                __typename: typeName,
                listItemCollection: {
                  items: dataUpcomingSoon,
                },
              },
            ],
          },
        };
      }
      if (type === 'ScrollingFeaturedGenreGameContainer') {
        return {
          ...sys,
          blocksCollection: {
            __typename: blocksCollection?.__typename ?? null,
            items: [
              {
                dataSource,
                description: blocksCollection?.description ?? null,
                openNewTab: blocksCollection?.openNewTab ?? false,
                queryValue: blocksCollection?.queryValue ?? null,
                title: blocksCollection?.title ?? null,
                type,
                __typename: typeName,
                ticker: blocksCollection?.ticker ?? null,
                listItemCollection: {
                  items: blocksCollection?.listItemCollection?.items.map((item: any) => {
                    return {
                      audio: item?.audio ?? null,
                      description: item?.description ?? null,
                      slug: item?.slug ?? null,
                      subtitle: item?.subtitle ?? null,
                      title: item?.title ?? null,
                      platform: item?.platform ?? null,
                      mainThumbnailImg: {
                        media: {
                          url: item?.mainThumbnailImg?.media?.url ?? null,
                        },
                      },
                    };
                  }),
                },
              },
            ],
          },
        };
      }

      return items;
    }
  );

  if (pageData?.data.pageCollection?.items?.[0]?.sectionCollection?.items) {
    pageData.data.pageCollection.items[0].sectionCollection.items = sectionCollection ?? [];
  }

  return {
    props: {
      paramFilter: filterData,
      paramSort,
      data: {
        globalData: pageData?.data?.globalData || {},
        pageCollection: {
          items: [
            {
              footer: pageData?.data?.pageCollection?.items[0]?.footer ?? {},
              navibar: pageData?.data?.pageCollection?.items[0]?.navibar ?? {},
              sectionCollection: {
                items: pageData?.data?.pageCollection?.items[0]?.sectionCollection?.items ?? [],
              },
              seoStandard: pageData?.data?.pageCollection?.items[0]?.seoStandard ?? {},
            },
          ],
        },
      },
      gameListingShooterAndAction: listGameByQueryValue ?? [],
      gameListingParty: partyListGame || [],
      locale: ctx.locale,
      newDataOurPicks,
      brandList,
      navData,
    },
    revalidate: REVALIDATE_TIME,
  };
};

export default Games;
